import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import {
	MuiThemeProvider as MuiThemeProviderV4,
	createMuiTheme,
} from '@material-ui/core/styles';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import HttpsRedirect from 'react-https-redirect';
import Notifications from 'react-notification-system-redux';
import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import Intercom from 'react-intercom';
import * as actions from '../actions';
import ContactUs from './index/ContactUs';
import EnterpriseDashboard from './dashboards/EnterpriseDashboard';
import Login from './register/Login';
import Register from './register/Register';
import ForgotPassword from './register/ForgotPassword';
import ResetPassword from './register/ResetPassword';

const muiTheme = createMuiTheme({
	typography: {
		fontFamily: '"Geist Sans", sans-serif'
	},
	palette: {
		primary: {
			main: '#c655d6'
		},
		secondary: {
			main: '#000000'
		}
	}
});

// Material-UI v0.x theme (prevents default teal buttons)
const legacyMuiTheme = getMuiTheme(lightBaseTheme, {
	fontFamily: 'Geist Sans, sans-serif',
	palette: {
		primary1Color: '#c655d6',
		accent1Color: '#c655d6',
		pickerHeaderColor: '#c655d6',
	},
});

// Create the Stripe object yourself...
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

class App extends Component {
	constructor(props) {
		super(props);
		this.loggedIn = this.loggedIn.bind(this);
		this.state = { show: false };
	}

	componentDidMount() {
		document.body.style.backgroundColor = '#f0f0f0';

		if (!this.props.auth) {
			this.fetchUser();
		}
	}

	componentWillUnmount() {
		document.body.style.backgroundColor = null;
	}

	fetchUser = async () => {
		const done = await this.props.fetchUser();
		if (done) {
			this.setState({ show: true });
		}
	};

	loggedIn() {
		return this.props.auth;
	}

	renderIntercom = () => {
		const { auth } = this.props;

		const user = {
			user_id: auth.username,
			email: auth.username
		};

		return (
			<div className="app">
				<Intercom appID="mfrf0y5w" {...user} />
			</div>
		);
	};

	render() {
		const { notifications } = this.props;

		const style = {
			NotificationItem: {
				// Override the notification item
				DefaultStyle: {
					// Applied to every notification, regardless of the notification level
				}
			}
		};
		return (
			<div>
				<Notifications notifications={notifications} style={style} />

				<MuiThemeProvider muiTheme={legacyMuiTheme}>
					<MuiThemeProviderV4 theme={muiTheme}>
						<HttpsRedirect>
							{this.state.show ? this.renderIntercom() : null}
							<BrowserRouter>
								<div>
									<Elements stripe={stripePromise}>
										<Switch>
											<Route
												exact
												path="/"
												render={() => {
													if (this.state.show) {
														if (this.loggedIn()) {
															// Check if the user is a corporate manager account

															// If we set the enterprise activated object to false, show them the login screen with error
															if (
																this.props.auth
																	.activated ===
																false
															) {
																return (
																	<Login
																		activated={
																			this
																				.props
																				.auth
																				.activated
																		}
																	/>
																);
															}

															return (
																<EnterpriseDashboard />
															);
														}

														return <Login />;
													}

													return <div />;
												}}
											/>

											<Route
												exact
												path="/dashboard"
												render={() => {
													if (this.state.show) {
														if (this.loggedIn()) {
															// Otherwise render the normal dashboard if activated
															if (
																this.props.auth
																	.activated
															) {
																return (
																	<EnterpriseDashboard />
																);
															}
															// Else show them login
														}

														return <Login />;
													}

													return <div />;
												}}
											/>

											<Route
												exact
												path="/contact-us"
												component={ContactUs}
											/>

											<Route
												exact
												path="/login"
												component={Login}
											/>

											<Route
												exact
												path="/forgot-password"
												component={ForgotPassword}
											/>

											<Route
												exact
												path="/reset-password/:token"
												component={ResetPassword}
											/>

											<Route
												exact
												path="/register"
												component={Register}
											/>

											<Route path="*" component={Login} />
										</Switch>
									</Elements>
								</div>
							</BrowserRouter>
						</HttpsRedirect>
					</MuiThemeProviderV4>
				</MuiThemeProvider>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
		waiting: state.waiting,
		notifications: state.notifications
	};
}

export default connect(mapStateToProps, actions)(App);



// WEBPACK FOOTER //
// ./src/components/App.js